import { createServerFn } from "@tanstack/react-start";
import { supabaseAdmin } from "@/integrations/supabase/client.server";
import { getNumberSetting } from "@/lib/server/appSettings";

const UI_TO_DB: Record<string, string> = {
  lover: "decouverte",
  ambassador: "active",
  superstar: "elite",
};

export type PublicRewardRule = {
  event_type: string;
  reward_type: string;
  value: number;
  currency: string | null;
  min_order_value: number | null;
  max_orders_per_referral: number | null;
  max_reward_per_event: number | null;
  note: string | null;
};

export const getPublicTierRewards = createServerFn({ method: "GET" })
  .inputValidator((input: { tierUiKey: string }) => {
    if (!UI_TO_DB[input.tierUiKey]) throw new Error("INVALID_TIER");
    return input;
  })
  .handler(async ({ data }) => {
    const dbTier = UI_TO_DB[data.tierUiKey];
    const nowIso = new Date().toISOString();
    const { data: rows, error } = await supabaseAdmin
      .from("ambassador_reward_rules")
      .select(
        "event_type, reward_type, value, currency, min_order_value, max_orders_per_referral, max_reward_per_event, note, active_from",
      )
      .eq("tier", dbTier as "decouverte" | "active" | "elite")
      .lte("active_from", nowIso)
      .or(`active_to.is.null,active_to.gt.${nowIso}`)
      .order("active_from", { ascending: false });

    if (error) {
      console.warn("[getPublicTierRewards] failed", error);
      return { tier: dbTier, rules: [] as PublicRewardRule[], pointValueAed: 0.1 };
    }

    const seen = new Set<string>();
    const rules: PublicRewardRule[] = (rows ?? [])
      .filter((r) => {
        if (seen.has(r.event_type)) return false;
        seen.add(r.event_type);
        return true;
      })
      .map((r) => ({
        event_type: r.event_type,
        reward_type: r.reward_type,
        value: Number(r.value ?? 0),
        currency: r.currency,
        min_order_value: r.min_order_value !== null ? Number(r.min_order_value) : null,
        max_orders_per_referral: r.max_orders_per_referral,
        max_reward_per_event:
          r.max_reward_per_event !== null ? Number(r.max_reward_per_event) : null,
        note: r.note,
      }));

    const pointValueAed = await getNumberSetting("public_loyalty_point_value_in_aed", 0.1);

    return { tier: dbTier, rules, pointValueAed };
  });
